export default {
    init() {
    },
    finalize() {
        (function () {

            if ($('.nurses-finder--notinghamshire').length > 0)
                return;

            // grab the nursing json
            var schoolNurseJson = window.schoolNurseOutput;

            var nurseSelect = $('#nurses-finder-select');

            // Nurses finder
            var nursesFinderOutput = $('#nurses-finder-output'),
                title = $('#nurses-finder-output-title'),
                postcode = $('#nurses-finder-output-postcode'),
                nursingTeam = $('#nurses-finder-output-school-nursing-team'),
                nursingBase = $('#nurses-finder-output-school-nursing-base'),
                phone = $('#nurses-finder-output-phone');

            // Grab the school nurse
            function filterNurseJson(id) {
                return schoolNurseJson.filter(function (el) {
                    return el.id == id;
                })[0];
            }

            function hideSchool() {
                nursesFinderOutput.addClass('d-none');

                title.text('No school selected');
                postcode.text('');
                nursingTeam.text('');
                nursingBase.text('');
                phone.text('');
                phone.attr('href', '');
            }

            function showSchool(json) {
                nursesFinderOutput.removeClass('d-none');

                title.text(json.title);
                postcode.text(json.postcode);
                nursingTeam.text(json.school_nurse_team);
                nursingBase.text(json.school_nurse_base);
                phone.text(json.phone);
                phone.attr('href', 'tel:' + json.phone);
            }

            nurseSelect.on('change', function () {
                var self = this;
                var nurseJson = filterNurseJson(self.value);

                if (self.value == 0) {
                    hideSchool();
                } else {
                    showSchool(nurseJson);
                }

            });

        }());

        (function () {

            if (!$('.nurses-finder--notinghamshire').length)
                return;

            // grab the nursing json
            var schoolNurseJson = window.schoolNurseOutput;

            var nurseSelect = $('#nurses-finder-select');

            var nursesFinderOutput = $('#nurses-finder-output'),
                title = $('#nurses-finder-output-title'),
                info = $('#nurses-finder-output-info');

            // Grab the school nurse
            function filterNurseJson(id) {
                return schoolNurseJson.filter(function (el) {
                    return el.id == id;
                })[0];
            }

            function hideSchool() {
                nursesFinderOutput.addClass('d-none');

                title.text('No school selected');
                info.text('');
            }

            function showSchool(json) {
                nursesFinderOutput.removeClass('d-none');

                title.text(json.title);
                info.text('');

                for (var i = 0; i < json.team_data.length; i++) {

                    var output = '',
                        team_title = json.team_data[i].title,
                        content = json.team_data[i].content;

                    output = '<div class="nurses-finder__info__block">' +
                        '<h3 class="nurses-finder__info__title">' + team_title + '</h3>' +
                        '<div class="nurses-finder__info__content">' + content + '</div>' +
                        '</div>';

                    info.append(output);

                }
            }

            nurseSelect.on('change', function () {
                var self = this;
                var nurseJson = filterNurseJson(self.value);

                if (self.value == 0) {
                    hideSchool();
                } else {
                    showSchool(nurseJson);
                }

            });

        }());
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateSchoolNurses.js